var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgOk = function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 33,
    viewBox: "0 0 19 33",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.12 25c0 1.2-.24 2.288-.72 3.264a7.894 7.894 0 01-1.944 2.52 9.373 9.373 0 01-2.784 1.632 9.148 9.148 0 01-3.192.576c-1.136 0-2.216-.2-3.24-.6-1.04-.4-1.96-.96-2.76-1.68a8.131 8.131 0 01-1.92-2.568 7.08 7.08 0 01-.72-3.168c0-1.2.248-2.288.744-3.264a7.77 7.77 0 011.992-2.496 9.373 9.373 0 012.784-1.632 8.886 8.886 0 013.144-.576 9.014 9.014 0 016.024 2.28c.8.72 1.432 1.568 1.896 2.544.464.976.696 2.032.696 3.168zm-8.64 6.312a8.04 8.04 0 002.688-.456 7.465 7.465 0 002.28-1.296 6.608 6.608 0 001.584-1.992c.384-.784.576-1.64.576-2.568 0-.976-.2-1.848-.6-2.616a6.379 6.379 0 00-1.632-1.992 7.378 7.378 0 00-2.304-1.272 8.01 8.01 0 00-5.256.024 7.21 7.21 0 00-2.28 1.32 6.15 6.15 0 00-1.584 1.992c-.384.768-.576 1.616-.576 2.544 0 .96.2 1.832.6 2.616a6.3 6.3 0 001.632 1.992 7.748 7.748 0 002.28 1.272 8.009 8.009 0 002.592.432z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.84H.984v-1.68h9.888L.96 2.778V.929l7.488 6.96L18 .568v1.896L9.456 8.968l3.312 3.192H18v1.68z",
    fill: "#fff"
  })));
};

export default SvgOk;